<script lang="ts">
	import AbleyButton from './AbleyButton.svelte';
	import IconX from '#lib/assets/x-mark.svg?raw';

	interface Props {
		onclick: () => void;
		/** Name what it closes ("Close dialog", "Close filters"…). */
		'aria-label': string;
	}

	const { onclick, 'aria-label': ariaLabel }: Props = $props();
</script>

<AbleyButton variant="text" size="sm" {onclick} aria-label={ariaLabel}>
	{@html IconX}
</AbleyButton>
